/**
 * The class manages the dispatching of UI events.
 */
export default class ACTEventDispatcher {
  constructor(itemId, handler) {
    this.itemId = itemId;
    this.handler = handler;
  }
  dispatch(type, analyticsEvent) {
    this._dispatch({
      type,
      itemId: this.itemId,
      analyticsEvent
    });
  }
  dispatchError(type, error) {
    this._dispatch({
      type,
      itemId: this.itemId,
      error
    });
  }
  _dispatch(event) {
    if (this.handler) {
      this.handler(event);
    }
  }
}